__turbopack_context__.v({
  "actionButtonWrapper": "lwWs6a_actionButtonWrapper",
  "navActions": "lwWs6a_navActions",
  "navContainer": "lwWs6a_navContainer",
  "navLeftContainer": "lwWs6a_navLeftContainer",
  "navMiddleContainer": "lwWs6a_navMiddleContainer",
  "navRightContainer": "lwWs6a_navRightContainer",
  "navToggle": "lwWs6a_navToggle",
  "whiteLabeled": "lwWs6a_whiteLabeled",
});
